import { Badge, Button, Descriptions, Icon } from "antd";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { generate_query_set, handleApiExceptions, } from "../../../../app_methods";
import { VENDOR_APPROVAL_STATUS, VENDOR_INVOICE_STATUS_TYPES } from "../../../../constants";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { EaseTable } from "../../../../libs/EaseTable";
import { VendorInvoice } from "../../../../models/vendorPayouts";
import { Text4 } from "../../../../styles";
import { BulkUploadModal, ContentCard } from "../../../Common";
import { VendorInvoiceModal } from "../../../Common/VendorPayouts/Modals/VendorInvoice";
import { CreatePermissionHoc, PermissionHoc } from "../../../HOC";
import { getVendorInvoiceColumns, vendorInvoiceTableFilterNodes } from "./constants";
import VendorInvoiceDetailsDrawer from "./invoice_details_drawer";
import { updateCurrentUserAction } from "../../../../redux/actions";
import { connect } from "react-redux";

const VendorInvoiceList = (props) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    showTotal: (total) => `Total ${total} Records`,
  });
  const [filters, setFilters] = useState({});
  const [showVendorInvoiceModal, setshowVendorInvoiceModal] = useState(false);
  const [showUploadInvoiceModal, setShowUploadInvoiceModal] = useState(false);
  const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
  const [showVendorInvoiceDetailsDrawer, setShowVendorInvoiceDetailsDrawer] = useState(false);
  const [activeInvoice, setActiveInvoice] = useState({});
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

  const fetchList = async (_pagination = pagination, _filters = filters) => {
    setIsTableLoading(true);
    const response = await VendorInvoice.list({
      ...{ pageSize: _pagination.pageSize, current: _pagination.current },
      ..._filters,
    });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    setVendorInvoices(generate_query_set(VendorInvoice, response.data.results));
    setPagination({ ...pagination, total: response.data.count });
    setIsTableLoading(false);
    if (activeInvoice.id) {
      setActiveInvoice(new VendorInvoice(response.data.results.find((x) => x.id === activeInvoice.id)));
    }
  };

  useEffect(() => {
    props.onChildMount();
    fetchList({ ...pagination }, { ...filters });
  }, []);

  const toggleVendorInvoiceModal = (vendorInvoice = {}) => {
    setActiveInvoice(vendorInvoice);
    setshowVendorInvoiceModal(!showVendorInvoiceModal);
  };

  const toggleVendorInvoiceDetailsDrawer = (obj = {}) => {
    setActiveInvoice(obj);
    setShowVendorInvoiceDetailsDrawer(!showVendorInvoiceDetailsDrawer);
  };

  const toggleStatusInfoDrawer = () => {
    setShowStatusInfoDrawer(!showStatusInfoDrawer);
  };

  const toggleBulkUploadModal = () => {
    setShowBulkUploadModal(!showBulkUploadModal);
  };

  const PermissableButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null, });

  const CreateButton = CreatePermissionHoc({ create_permission: 'VENDOR_INVOICE_WRITE', bulk_permission: 'BENEFICIARIES_BULK_UPLOAD' }, { onCreateClick: toggleVendorInvoiceModal, onBulkClick: toggleBulkUploadModal, createText: <><Icon type="plus" /> Create Invoice </>, bulkText: "Bulk Upload" });

  const tableColumns = getVendorInvoiceColumns({
    toggleVendorInvoiceDetailsDrawer,
    toggleStatusInfoDrawer,
    toggleVendorInvoiceModal
  });

  let filterNodes = vendorInvoiceTableFilterNodes({
    vendors: props.current_user
  });


  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchList(_pagination, tableInfo.filters);
  };

  const onPageChange = (_pagination) => {
    setPagination({ ..._pagination });
    fetchList({ ..._pagination }, filters);
  };


  const onInvoiceSave = () => {
    toggleVendorInvoiceModal();
    fetchList(pagination, filters);
  }

  return (
    <div>
      <ContentCard className="p-3">
        <div className="w-100 d-flex justify-content-end">

          {/* <PermissableButton
            type="primary"
            icon="plus"
            style={{ marginLeft: "10px" }}
            required_permission="VENDOR_INVOICE_WRITE"
            onClick={() => toggleVendorInvoiceModal()}
          >
            Create Invoice
          </PermissableButton> */}
          <CreateButton />

        </div>
        <EaseTable
          rowKey="uuid"
          loading={isTableLoading}
          data={vendorInvoices}
          columns={tableColumns}
          fixedSelectable={!isMobile}
          handleTableChange={handleTableChange}
          pagination={pagination}
          totalRecords={pagination.total}
          filterNodes={filterNodes}
          toggleVendorInvoiceModal={() => toggleVendorInvoiceModal()}
        />

        <VendorInvoiceModal
          visible={showVendorInvoiceModal}
          toggleVendorInvoiceModal={toggleVendorInvoiceModal}
          onInvoiceSave={onInvoiceSave}
          vendorInvoice={activeInvoice}
        />
      </ContentCard>

      <EaseDrawer
        visible={showStatusInfoDrawer}
        onClose={toggleStatusInfoDrawer}
        hideFooter
        title="Payment Statuses"
        width={500}
      >
        <Descriptions
          bordered
          className="mt-3"
          size="small"
          layout="horizontal"
          column={1}
        >
          {Object.keys(VENDOR_INVOICE_STATUS_TYPES).map((key, index) => {
            return (
              <Descriptions.Item
                label={
                  <Badge
                    color={VENDOR_INVOICE_STATUS_TYPES[key].color}
                    text={
                      <Text4>{VENDOR_INVOICE_STATUS_TYPES[key].label}</Text4>
                    }
                  />
                }
              >
                {VENDOR_INVOICE_STATUS_TYPES[key].description}
              </Descriptions.Item>
            );
          })}
        </Descriptions>
      </EaseDrawer>

      <VendorInvoiceDetailsDrawer
        toggleVendorInvoiceDetailsDrawer={toggleVendorInvoiceDetailsDrawer}
        visible={showVendorInvoiceDetailsDrawer}
        onClose={() => toggleVendorInvoiceDetailsDrawer()}
        invoice={activeInvoice}
        fetchList={fetchList}
      />

      <BulkUploadModal
        history={props.history}
        visible={showBulkUploadModal}
        toggleBulkUploadModal={toggleBulkUploadModal}
        onSuccess={() => fetchList(pagination, filters)}
        type="vendor_invoice"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHoc(VendorInvoiceList, "VENDOR_INVOICE_READ"));
